import Vue from 'vue';
import VueRouter from 'vue-router';
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta';
// Adds a loading bar at the top during page loads.
import NProgress from 'nprogress/nprogress';
import store from '@/state/store';
import routes from '@/router/routes';
import { subItems } from '@/assets/scripts/menu/menu';
import {_find, _isEmpty} from '@samclick-lodash';
import MenuStore from '@/state/modules/menu'
import CommonsStore from '@/state/modules/commons';
import * as appStorageUtil from "@/utils/localstorage-util";
import i18n from '@/i18n';

Vue.use(VueRouter);
Vue.use(VueMeta, {
    // The component option name that vue-meta looks for meta info on.
    keyName: 'page',
});

//@ts-ignore
const router = new VueRouter({
    // Use the HTML5 history API (i.e. normal-looking routes)
    // instead of routes with hashes (e.g. example.com/#/about).
    // This may require some server configuration in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    mode: 'hash',
    linkActiveClass: "is-Active",
    routes,
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    },
});

// Before each route evaluates...
//@ts-ignore
router.beforeEach((routeTo, routeFrom, next) => {
    if (window.location.protocol !== 'https:' && process.env.NODE_ENV === 'production') {
        window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
    }

    function redirectToLogin() {
    // Pass the original route to the login component
        next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }

    // If this isn't an initial page load...
    if (routeFrom.name !== null) {
    // Start the route progress bar.
        NProgress.start();
    }

    // Check if auth is required on this route
    // (including nested routes).
    //@ts-ignore
    const authRequired = routeTo.matched.some(route => route.meta.authRequired);
    // If auth isn't required for the route, just continue.
    if (!authRequired) return next();

    if (routeTo.name === 'dashboard' && !_isEmpty(routeTo.query.token)){
        const token = routeTo.query.token || ''
        return appStorageUtil.parseJWT(token.toString().replace('%20', ' ')) ? next() : redirectToLogin();
    }

    // If auth is required and the user is logged in...
    if (!_isEmpty(appStorageUtil.getCookiesItem(appStorageUtil.AUTH_TOKEN))) {
    // Validate the local user token...
        return appStorageUtil.parseJWT(appStorageUtil.getAuthorizationToken()) ? next() : redirectToLogin();
    }

    // If auth is required and the user is NOT currently logged in,
    // redirect to login.
    redirectToLogin();
});

//@ts-ignore
router.beforeResolve(async (routeTo, routeFrom, next) => {
    // Create a `beforeResolve` hook, which fires whenever
    // `beforeRouteEnter` and `beforeRouteUpdate` would. This
    // allows us to ensure data is fetched even when params change,
    // but the resolved route does not. We put it in `meta` to
    // indicate that it's a hook we created, rather than part of
    // Vue Router (yet?).
    try {
    // For each matched route...
        for (const route of routeTo.matched) {
            await new Promise((resolve, reject) => {
                // If a `beforeResolve` hook is defined, call it with
                // the same arguments as the `beforeEnter` hook.
                if (route.meta && route.meta.beforeResolve) {
                    //@ts-ignore
                    route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                        // If the user chose to redirect...
                        if (args.length) {
                            // If redirecting to the same route we're coming from...
                            if (routeFrom.name === args[0].name) {
                                // Complete the animation of the route progress bar.
                                NProgress.done();
                            }
                            // Complete the redirect.
                            next(...args);
                            reject(new Error('Redirected'));
                        } else {
                            resolve();
                        }
                    });
                } else {
                    // Otherwise, continue resolving the route.
                    resolve();
                }
            });
        }
    // If a `beforeResolve` hook chose to redirect, just return.
    } catch (error) {
        return;
    }

    // If we reach this point, continue resolving the route.
    next();
});

// When each route is finished evaluating...
//@ts-ignore
router.afterEach((routeTo, routeFrom) => {
    // set parent id every successful change of routes
    const routeInfo = _find(subItems, { href: routeTo.name });

    MenuStore.selectParentMenu(routeInfo ? routeInfo.parent : -1)

    // Complete the animation of the route progress bar.
    NProgress.done();
});

export default router;
